export default {
  avatar: {
    title: "تعديل الصورة الرمزية",
  },
  bindRole: {
    allServers: "جميع الخوادم",
    bindFailed: "فشل ربط الشخصية",
    bindSuccess: "تم ربط الشخصية بنجاح",
    getRoleListFailed: "فشل الحصول على قائمة الشخصيات",
    getServerListFailed: "فشل الحصول على قائمة الخوادم",
    modifyTitle: "تعديل ربط الشخصية",
    noRole: "لا توجد شخصيات حاليًا",
    recentServers: "الخادم الخاص بك",
    role: "اسم الشخصية:",
    rolePlaceholder: "يرجى اختيار شخصية",
    server: "الخادم:",
    serverPlaceholder: "الرجاء اختيار الخادم",
    title: "ربط الشخصية",
  },
  commentModal: {
    placeholder: "اكتب تعليقًا...",
    replyTo: "رد على {username}",
    title: "تعليق",
  },
  common: {
    cancel: "إلغاء",
    confirm: "حسنًا",
    landscapeTip: "يرجى تدوير هاتفك إلى الوضع العمودي للحصول على تجربة أفضل",
    loadMore: "اسحب لأعلى لتحميل المزيد",
    loading: "جارٍ التحميل...",
    loadingMore: "جارٍ تحميل المزيد...",
    noMore: "لا يوجد المزيد من البيانات",
    refreshFailed: "فشل التحديث",
    refreshSuccess: "تم التحديث بنجاح",
    submit: "تقديم",
    all: "الكل",
    language: "اللغة",
  },
  error: {
    50002: "الرمز غير صالح أو منتهي الصلاحية",
    50006: "الاسم المستعار مستخدم من قبل مستخدم آخر",
    50007:
      "يمكنك تغيير اسمك المستعار مرة واحدة فقط شهريًا، لقد قمت بتغييره هذا الشهر",
    50008: "النقاط لا تكفي",
    50301: "ليس لديك صلاحية للنشر",
    50302: "لقد وصلت إلى الحد الأقصى لعدد المنشورات",
    50303: "طول المحتوى لا يفي بالمتطلبات",
    50304: "المحتوى يحتوي على كلمات حساسة، يرجى التعديل والمحاولة مرة أخرى",
    50308: "ليس لديك الإذن لعرض هذه المشاركة",
    50309: "تم حذف أو نقل المنشور",
    50351: "تم إغلاق الموضوع، لا يمكن الرد",
    50353: "ليس لديك صلاحية للرد",
    50354: "الرد ممنوع في هذا القسم",
    50355: "النشر متكرر جدًا، حاول مرة أخرى لاحقًا",
    50356: "لقد وصل عدد المنشورات في الساعة إلى الحد الأقصى",
    50361: "التعليق غير موجود",
    50500: "ليس لديك صلاحية البحث",
    50501: "تم إغلاق وظيفة البحث",
    50502: "المحتوى يحتوي على كلمات حساسة، يرجى التعديل والمحاولة مرة أخرى",
    50505: "البحث متكرر جدًا، يرجى المحاولة مرة أخرى لاحقًا",
    50703: "فشل اجتياز مراجعة الصورة",
    50704: "محتوى الصورة لا يتوافق مع المعايير",
    50214: "فشلت المشاركة: لم تنضم إلى @:shareModal.alliance.",
    common: "فشلت العملية، يرجى المحاولة لاحقاً",
  },
  home: {
    gameName: "Puzzles & Survival",
    hasSigned: "تم تسجيل الحضور",
    loginInSuccess: "تم تسجيل الدخول بنجاح",
    pleaseLogin: "يرجى تسجيل الدخول أولاً",
    loginNow: "تسجيل الدخول",
    pullToRefresh: "اسحب للتحديث",
    releaseToRefresh: "حرر للتحديث",
    signFailed: "فشل تسجيل الحضور",
    signIn: "تسجيل الحضور",
    signInFailedTip: "فشل تسجيل الحضور، يرجى المحاولة لاحقًا",
    signSuccess: "تم تسجيل الحضور بنجاح",
    goToShop: "انتقل إلى مركز النقاط",
    sortByLastPost: "أحدث التعليقات",
    sortByTime: "الأحدث",
    tags: {
      activity: "حدث",
      chats: "تواصل",
      guide: "استراتيجية",
      recommend: "توصية",
      news: "أخبار",
    },
    unboundRole: "لم يتم ربط الشخصية",
  },
  linkModal: {
    close: "Close",
    textLabel: "Link Text",
    textPlaceholder: "Please enter link text",
    title: "Insert Link",
    urlLabel: "Link URL",
    urlPlaceholder: "Please enter link URL",
    viewTitle: "View Link",
  },
  maintenance: {
    title: "الصفحة قيد الصيانة",
    message:
      "عذرًا، منتدى اللعبة قيد الصيانة حاليًا. يرجى المحاولة مرة أخرى لاحقًا.",
  },
  mentionModal: {
    searchPlaceholder: "ابحث عن المستخدم",
    title: "اختر المستخدم",
  },
  nicknameModify: {
    alreadyRenamed:
      "يمكنك تعديل الاسم المستعار مرة واحدة فقط شهريًا، وقد قمت بتعديله هذا الشهر",
    changedNickname: "تغيير الاسم",
    cost: "استهلاك",
    date: "التاريخ",
    getMore: "احصل",
    nicknameTooShort: "يجب ألا يقل الاسم عن 3 أحرف",
    coinNotEnough: "النقاط لا تكفي",
    placeholder: "الرجاء إدخال الاسم",
    recordTitle: "سجل التعديلات",
    sameNickname: "لا يمكن أن يكون الاسم مماثلاً للاسم الحالي",
    success: "تم حفظ التعديل",
    viewRecord: "عرض سجل التعديلات",
  },
  notice: {
    empty: "لا توجد رسائل حاليًا",
    likeComment: "{username} أعجب بتعليقك",
    likePost: "{username} أعجب بمنشورك",
    mentionComment: "{username} أشار إلى تعليقك",
    mentionPost: "{username} أشار إلى منشورك",
    replyComment: "{username} قام بالرد على تعليقك",
    replyPost: "{username} قام بالرد على منشورك",
    system: "إشعار النظام",
    tabs: {
      like: "إعجاب",
      mention: "الإشارة إليّ",
      notification: "الإشعارات",
      reply: "الرد على رسائلي",
    },
    title: "إشعارات الرسائل",
  },
  operateModal: {
    confirmDelete: "هل أنت متأكد من حذف هذا المنشور؟",
    copyFailed: "فشل النسخ",
    copyLink: "انسخ الرابط",
    copySuccess: "تم النسخ",
    delete: "حذف",
    shareToGame: "مشاركة في اللعبة",
    deleteFailed: "فشل الحذف",
    deleteSuccess: "تم الحذف",
    title: "إجراء",
  },
  shareModal: {
    selectChannelTitle: "يرجى اختيار القناة للمشاركة",
    channelLabel: "القناة",
    channelPlaceholder: "اختر القناة",
    alliance: "التحالف",
    shareSuccess: "تمت المشاركة بنجاح",
    continueBrowse: "متابعة التصفح",
    goToGame: "عرض في اللعبة",
    noThreadTip: "يرجى فتح منشور أولاً",
  },
  post: {
    create: {
      contentEmpty: "لا يمكن أن يكون المحتوى فارغًا",
      contentPlaceholder: "ما ترغب في قوله في هذه اللحظة...",
      failed: "فشل النشر",
      fileTooLarge: "حجم الملف يتجاوز الحد (الحد الأقصى {maxSize})",
      image: "صورة",
      imageSizeLimit: "يجب أن يكون حجم الصورة أقل من 5 ميغابايت",
      imageUploadFailed: "فشل رفع الصورة",
      imageUploadSuccess: "تم رفع الصورة",
      imageUploading: "جارٍ رفع الصورة، يرجى الانتظار...",
      invalidFileType: "نوع الملف غير مدعوم",
      maxCharsReached: "تم الوصول إلى الحد الأقصى لعدد الأحرف ({max} حرف)",
      mention: "{'@'}",
      selectBoard: "اختر القسم",
      topicLabel: "الموضوع",
      submit: "نشر",
      submitting: "جارٍ النشر...",
      success: "تم النشر",
      title: "نشر",
      titleEmpty: "لا يمكن أن يكون العنوان فارغًا",
      titlePlaceholder: "يرجى إدخال العنوان",
      video: "فيديو",
      videoSizeLimit: "يجب أن يكون حجم الفيديو أقل من 50 ميغابايت",
      videoUploadFailed: "فشل رفع الفيديو",
      videoUploadSuccess: "تم رفع الفيديو",
      videoUploading: "جارٍ رفع الفيديو، يرجى الانتظار...",
    },
    title: "المنشورات",
  },
  postDetail: {
    allComments: "جميع ردود {num}",
    allReplies: "جميع الردود",
    author: "الكاتب",
    cancelFavorite: "تم إلغاء الحفظ",
    commentTooShort: "يجب ألا يقل محتوى التعليق عن 5 أحرف",
    translate: "ترجمة",
    translating: "جارٍ الترجمة...",
    translateSuccess: "تمت الترجمة بنجاح",
    translateFailed: "فشلت الترجمة",
    translatedTo: "تمت الترجمة إلى",
    earliest: "أقدم رد",
    favoriteSuccess: "تم الحفظ بنجاح",
    floor: "الطابق",
    latest: "أحدث رد",
    loadFailed: "فشل التحميل",
    noContent: "لا يوجد محتوى",
    onlyAuthor: "عرض الكاتب فقط",
    reply: "رد",
    replyTo: "رد",
    sendFailed: "فشل الإرسال",
    sendSuccess: "تم الإرسال بنجاح",
    sending: "جارٍ الإرسال...",
    viewOriginalPost: "عرض المنشور الأصلي",
    writeSomething: "قل شيئًا...",
  },
  profile: {
    addLikeSuccess: "تم الإعجاب",
    cancelLikeSuccess: "تم إلغاء الإعجاب",
    communityId: "معرف المجتمع",
    editNickname: "تعديل الاسم",
    followSuccess: "تمت المتابعة بنجاح",
    followed: "تمت المتابعة",
    followers: "المتابعين",
    follow: "متابعة",
    likes: "الإعجابات",
    noFavorites: "لا توجد مفضلات",
    noPosts: "لا توجد تحديثات",
    shopLabel: "متجر النقاط",
    tabs: {
      favorites: "محفوظاتي",
      posts: "حالاتي",
    },
    title: "الملف الشخصي",
    unfollowSuccess: "تم إلغاء المتابعة",
  },
  search: {
    btn: "بحث",
    empty: "لا توجد نتائج بحث ذات صلة",
    filter: {
      dateline: "الأحدث",
      title: "ترتيب",
      views: "شائع",
    },
    historyTitle: "سجل البحث",
    hotTitle: "الأكثر بحثًا",
    relatedPosts: "المنشورات ذات الصلة",
    tabs: {
      post: "المنشورات",
      user: "المستخدم",
    },
  },
  setting: {
    about: "معلومات عنا",
    logout: "تسجيل الخروج",
    logoutSuccess: "تم تسجيل الخروج",
    privacy: "سياسة الخصوصية",
    service: "شروط الخدمة",
    title: "الإعدادات",
  },
  shop: {
    emptyTip: "المتجر قيد الإنشاء، ترقبوا الجديد قريباً",
    record: "سجل الاستبدال",
    title: "مركز الاستبدال",
    bindRole: "ربط الشخصية",
    switchRole: "Switch Character",
    tabs: {
      tasks: "مهام النقاط",
      rewards: "استبدال المكافآت",
    },
    taskInProgress: "قيد التنفيذ",
    taskCompleted: "مكتمل",
    goToComplete: "إكمال",
    exchange: "استبدال",
    exchanged: "تم الاستبدال",
    exchangeConfirmTitle: "تأكيد الاستبدال؟",
    currentCoins: "النقاط الحالية",
    costCoins: "النقاط المستهلكة",
    receiveRole: "الشخصية المستلمة",
    exchangeSuccess: "تم الاستبدال بنجاح",
    exchangeFailed: "فشل الاستبدال",
  },
  exchangeRecord: {
    time: "الوقت",
    content: "المحتوى",
    points: "النقاط",
    empty: "لا توجد سجلات استبدال",
  },
  tabBar: {
    home: "الصفحة الرئيسية",
    notice: "الرسائل",
    profile: "الخاص بي",
  },
  time: {
    hoursAgo: "قبل {hours} من الساعات",
    minutesAgo: "قبل {minutes} من الدقائق",
  },
};
